import React, { FC, useContext, createContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectTenant } from 'state/tenant';
import { pick } from 'ramda';

export const RefererUrlContext = createContext<string | undefined>(undefined);

interface PropTypes {
  refererUrl: string | undefined;
}

export const RefererUrlProvider: FC<PropTypes> = ({ children, refererUrl }) => (
  <RefererUrlContext.Provider value={refererUrl}>
    {children}
  </RefererUrlContext.Provider>
);

type ReferrerQueryParametersHook = () => { [k: string]: string };

export const useRefererParams: ReferrerQueryParametersHook = () => {
  const refererUrlString = useContext(RefererUrlContext);
  const {
    enabledFeatures: { referrerParams: referrerParamsEnabledFeature },
  } = useSelector(selectTenant);

  return useMemo(() => {
    if (!refererUrlString) return {};
    if (!referrerParamsEnabledFeature) return {};

    const whitelist =
      referrerParamsEnabledFeature && referrerParamsEnabledFeature.whitelist;

    const referrerUrl = new URL(refererUrlString);

    const referredQueryParams = Object.fromEntries(
      new URLSearchParams(referrerUrl.search),
    );

    const whitelistedReferredParams = whitelist
      ? pick(whitelist, referredQueryParams)
      : referredQueryParams;

    return whitelistedReferredParams;
  }, [refererUrlString, referrerParamsEnabledFeature]);
};

export default useRefererParams;
